import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isNull from "lodash/isNull";
import _isUndefined from "lodash/isUndefined";
import "core-js/modules/es.math.sign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect, useRef } from 'react';
import Browser from "../Utility/Browser";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var countdownVariants = ['date', 'datetime'];
export var Countdown = function Countdown(_ref) {
  var endDateUTCTime = _ref.endDateUTCTime,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'datetime' : _ref$variant,
    _ref$countdownEndMess = _ref.countdownEndMessage,
    countdownEndMessage = _ref$countdownEndMess === void 0 ? '' : _ref$countdownEndMess,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
    _ref$suffix = _ref.suffix,
    suffix = _ref$suffix === void 0 ? '' : _ref$suffix,
    _ref$unitLabels = _ref.unitLabels,
    unitLabels = _ref$unitLabels === void 0 ? {
      day: {
        singular: 'Day',
        plural: 'Days'
      },
      hour: {
        singular: 'Hour',
        plural: 'Hours'
      },
      minute: {
        singular: 'Minute',
        plural: 'Minutes'
      }
    } : _ref$unitLabels;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    currentUserUTCDateTime = _useState2[0],
    setCurrentUserUTCDateTime = _useState2[1];
  var interval = useRef();
  useEffect(function () {
    setCurrentUserUTCDateTime(new Date());

    // Refresh the countdown every 30 seconds.
    interval.current = setInterval(function () {
      return setCurrentUserUTCDateTime(new Date());
    }, 30000);
    return function () {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);

  // Takes two date objects and finds difference between them.
  var timeDifference = function timeDifference(end, current) {
    // getTime() returns UTC number for given input
    var difference = end.getTime() - current.getTime();
    var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
    difference -= daysDifference * 1000 * 60 * 60 * 24;

    // If days is 0 or below, countdown is over.
    if (Math.sign(daysDifference) < 0) {
      return null;
    }
    var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
    difference -= hoursDifference * 1000 * 60 * 60;
    var minutesDifference = Math.floor(difference / 1000 / 60);
    difference -= minutesDifference * 1000 * 60;
    var secondsDifference = Math.floor(difference / 1000);
    return {
      days: daysDifference,
      hours: hoursDifference,
      minutes: minutesDifference,
      seconds: secondsDifference
    };
  };

  // Applies word conjugation.
  var timeFormatter = function timeFormatter(unit, value) {
    if (value === 0) {
      return '';
    }
    if (!unitLabels || unit in unitLabels === false || !unitLabels[unit]) {
      return "".concat(value);
    }
    var unitObject = unitLabels[unit] || {};
    if (value === 1) {
      if (unitObject['singular']) {
        return "".concat(value, " ").concat(unitObject['singular']);
      } else {
        return "".concat(value);
      }
    } else if (unitObject['plural']) {
      return "".concat(value, " ").concat(unitObject['plural']);
    } else {
      return "".concat(value);
    }
  };
  var endDate = new Date(endDateUTCTime);
  // Don't return anything if we are missing required data.
  if (!endDateUTCTime || !currentUserUTCDateTime || endDate.toString() === 'Invalid Date') {
    return null;
  }
  var difference = timeDifference(endDate, currentUserUTCDateTime);

  // If we've passed the end of the countdown, unset the interval and show end text.
  var _Object = Object(difference),
    days = _Object.days,
    hours = _Object.hours,
    minutes = _Object.minutes,
    seconds = _Object.seconds;
  if (_isUndefined(difference) || _isNull(difference) || days === 0 && hours === 0 && minutes === 0 && seconds) {
    if (interval.current) {
      clearInterval(interval.current);
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: countdownEndMessage
    });
  }
  var dayConj = timeFormatter('day', days);
  var hourConj = timeFormatter('hour', hours);
  var minConj = timeFormatter('minute', minutes);
  var text = variant === 'date' ? days >= 1 ? "".concat(prefix, " ").concat(dayConj, " ").concat(suffix) : "".concat(prefix, " ").concat(hourConj, " ").concat(minConj, " ").concat(suffix) : "".concat(prefix, " ").concat(dayConj, " ").concat(hourConj, " ").concat(minConj, " ").concat(suffix);
  return Browser.isBrowser() ? /*#__PURE__*/_jsx("span", {
    className: className,
    children: text
  }) : null;
};